import { AxiosInstance } from "../axiosInstance";
import APP_URL_USERS from "src/constants/usuarios";

//ahora evitamos que el token siempre llegue desactualiaazdo
//y ademas de evitar la dupliacion, sin mandar el token manualmete como lo haciamos anteriomente
class ApiUsuarios {
  async crearUsuario(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_USERS.CREATE_USER,
        data,
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async eliminarUsuario(id) {
    try {
      const response = await AxiosInstance.post(APP_URL_USERS.DELETE_USER, {
        id,
      });
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async editarUsuario(data) {
    try {
      const response = await AxiosInstance.post(APP_URL_USERS.EDIT_USER, data);
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async listarUsuarios() {
    try {
      const response = await AxiosInstance.get(APP_URL_USERS.LIST_USERS);
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async listarTodosUsuarios(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_USERS.LIST_ALL_USERS,
        data,
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  // 📸 FOTO
  async actualizarFoto(formData) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_USERS.UPDATE_PHOTO,
        formData,
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  // ✍️ FIRMA
  async actualizarFirma(formData) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_USERS.UPDATE_FIRMA,
        formData,
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async accesoKids(id) {
    try {
      const response = await AxiosInstance.post(APP_URL_USERS.ACCESO_KIDS, id);
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async denegarKids(id) {
    try {
      const response = await AxiosInstance.post(APP_URL_USERS.DENEGAR_KIDS, id);
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async permisoReportes(usuarios) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_USERS.PERMISOS_REPORTES,
        usuarios,
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async userOnline(id) {
    try {
      const response = await AxiosInstance.post(APP_URL_USERS.USER_ONLINE, {
        id,
      });
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async userOffline(id) {
    try {
      const response = await AxiosInstance.post(APP_URL_USERS.USER_OFFLINE, {
        id,
      });
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async userOnlineCount() {
    try {
      const response = await AxiosInstance.post(
        APP_URL_USERS.USER_ONLINE_COUNT,
        {},
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async usersCumpleaneros(fecha) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_USERS.USERS_CUMPLEANEROS,
        { fecha },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async listarUsuariosPorPerfil(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_USERS.USERS_BY_PROFILE,
        data,
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }
}

export default new ApiUsuarios();
